export default (timestamp) => {
  const daysInTimestamp = timestamp * 1000 - Date.now();
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.ceil(daysInTimestamp / oneDay);
};
